import { initializeApp } from 'firebase/app';
import { getAuth, GoogleAuthProvider, browserLocalPersistence, setPersistence } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';
var firebaseConfig = {
    apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
    authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
    projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
    storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
    messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
    appId: process.env.REACT_APP_FIREBASE_APP_ID
};
if (!firebaseConfig.apiKey || firebaseConfig.apiKey === "undefined") {
    throw new Error("Missing Firebase API key in configuration");
}
export var authorizedDomains = [
    'geninvest-ai.web.app',
    'api.geninvest.ai',
    'www.geninvest.ai',
    'geninvest.ai',
    'geninvest-ai.firebaseapp.com'
];
var app = initializeApp(firebaseConfig);
var auth = getAuth(app);
setPersistence(auth, browserLocalPersistence).catch(function (error) {
    console.error('Error setting persistence:', error);
});
auth.useDeviceLanguage();
var googleProvider = new GoogleAuthProvider();
googleProvider.setCustomParameters({ prompt: 'select_account' });
export var db = getFirestore(app);
export { auth, googleProvider, app };
export default app;
